// extracted by mini-css-extract-plugin
export var layoutContainer = "_8s-0";
export var layoutContainerNoRounding = "_8s-6";
export var layoutContainerOpen = "_8s-5";
export var layoutContainerResizing = "_8s-1";
export var mainContent = "_8s-2";
export var resizeDivider = "_8s-3";
export var slidePanel = "_8s-4";